
import { defineComponent, computed, onMounted, watch, ref } from 'vue'
import { useStore } from 'vuex'
import { IStoreType } from '@/store/types'
import { IarchivesType } from '@/store/page-file/types'

export default defineComponent({
  setup() {
    // 获取阅读数
    const readNum = computed(() => {
      return store.state.pageNoteModule.articleList.reduce((pre: any, cur) => {
        return pre + cur.read
      }, 0)
    })
    const store = useStore<IStoreType>()
    let article = ref<number>()
    let discuss = ref<number>()
    let user_l = ref<number>()
    const categoryList = computed(() => {
      return store.state.pageFileModule.article
    })
    // 数据优化
    let optimize = () => {
      article.value = store.state.pageFileModule.article
      discuss.value = store.state.pageFileModule.discuss
      user_l.value = store.state.pageFileModule.user_l
    }
    watch(categoryList, (n) => {
      optimize()
    })
    onMounted(() => {
      if (!categoryList.value) {
        // 调用初始数据接口
        store.dispatch('pageFileModule/onCensus')
      } else {
        optimize()
      }
    })
    return {
      article,
      discuss,
      user_l,
      readNum
    }
  }
})
